export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/olvide-contrasena',
  RESET_PASSWORD: '/restablecer-contrasena',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  /** Panel del docente: accesos y datos según cursos asignados. */
  TEACHER_PORTAL: '/docente',
  /** Panel del estudiante: materias propias y accesos a notas, asistencia y seguimiento. */
  STUDENT_PORTAL: '/estudiante',
  /** Plan de aprendizaje personalizado (IA) desde datos propios del alumno. */
  STUDENT_LEARNING_PLAN: '/estudiante/plan-aprendizaje',
  /** Historial y resumen de asistencia propia. */
  STUDENT_ATTENDANCE: '/estudiante/asistencia',
  /** Comunicados institucionales para estudiantes. */
  STUDENT_ANNOUNCEMENTS: '/estudiante/comunicados',
  /** Panel del tutor/a institucional: alumnos asignados, planes y seguimiento. */
  TUTOR_PORTAL: '/tutor',
  /** Plan de acompañamiento de un alumno asignado (query ?alumno=id). */
  TUTOR_STUDENT_PLAN: '/tutor/plan-tutoria',
  /** Panel del padre/tutor legal: hijos vinculados y accesos a notas y asistencia. */
  PARENT_PORTAL: '/padre',
  /** Asistencia de tutelados (query ?alumno=id). */
  PARENT_ATTENDANCE: '/padre/asistencia',
  /** Plan de tutoría / acompañamiento del tutelado (query ?alumno=id). */
  PARENT_TUTOR_PLAN: '/padre/plan-tutoria',
  USERS: '/users',
  STUDENTS: '/students',
  TEACHERS: '/teachers',
  TUTORS: '/tutors',
  COURSES: '/courses',
  PERIODS: '/periods',
  ENROLLMENTS: '/enrollments',
  GRADES: '/grades',
  ATTENDANCE: '/attendance',
  /** Check-in de asistencia al escanear QR (cualquier usuario autenticado; pensado para estudiantes). */
  ATTENDANCE_QR_CHECKIN: '/asistencia/qr',
  CLASSROOMS: '/classrooms',
  LOGISTICS: '/logistica',
  FOLLOW_UP: '/follow-up',
  FOLLOW_UP_BATCHES: '/follow-up/batches',
  FOLLOW_UP_BATCH_QUESTIONS: '/follow-up/batch/:batchId',
  FOLLOW_UP_QUESTIONS: '/follow-up/questions',
  FOLLOW_UP_RESPONSES: '/follow-up/responses',
  NOTIFICATIONS: '/notifications',
  MESSAGES: '/messages',
  ANNOUNCEMENTS: '/announcements',
  REPORTS: '/reports',
  SETTINGS: '/settings',
  /** Guía de configuración inicial (ADMIN / SUPER_ADMIN). */
  INITIAL_SETUP: '/configuraciones-iniciales',
  /** Edición del nombre de institución (desde checklist de configuración inicial). */
  INITIAL_SETUP_INSTITUTION: '/configuraciones-iniciales/nombre-institucion',
  /** PDF del plan de estudios + extracción con IA (años, perfil de egresado). */
  INITIAL_SETUP_STUDY_PLAN: '/configuraciones-iniciales/plan-de-estudios',
  /** PDF + IA para listar materias y actividades del plan por año/ciclo. */
  INITIAL_SETUP_SUBJECTS: '/configuraciones-iniciales/materias-plan',
  /** PDF + IA para analizar correlatividades entre materias del plan. */
  INITIAL_SETUP_CORRELATIVITIES: '/configuraciones-iniciales/correlatividades',
  /** Carreras y planes curriculares (módulo Planes de estudios). */
  STUDY_PLANS: '/planes-de-estudio',
  STUDY_PLAN_CAREER: '/planes-de-estudio/carrera',
  GRADE_SCALES: '/escalas-de-notas',
  ACTA_BOOKS: '/libro-de-actas',
  ACTA_BOOK_DETAIL: '/libro-de-actas/libro',
  /** Consola de sistema: sin enlace en el menú; acceso directo. Roles ADMIN o SUPER_ADMIN. */
  SUPER_ADMIN_SYSTEM: '/sys/sa-cfg',
  /** El bicho: plan PDF + verificación de egreso del estudiante por PDF (IA). */
  EL_BICHO: '/el-bicho',
} as const

export function tutorStudentPlanPath(studentId: number | string): string {
  return `${ROUTES.TUTOR_STUDENT_PLAN}?alumno=${studentId}`
}

export function tutorStudentRecordPath(studentId: number | string): string {
  return `${ROUTES.STUDENTS}?expediente=${studentId}`
}

export function parentGradesPath(studentId: number | string): string {
  return `${ROUTES.GRADES}?alumno=${studentId}`
}

export const GRADES_QUERY_SECTION = 'seccion'
export const GRADES_SECTION_ACTAS = 'actas'

export function isGradesActasLocation(pathname: string, search: string): boolean {
  if (pathname !== ROUTES.GRADES) return false
  return new URLSearchParams(search).get(GRADES_QUERY_SECTION) === GRADES_SECTION_ACTAS
}

export function gradesCursadaPath(params?: Record<string, string>): string {
  const qs = new URLSearchParams(params)
  qs.delete(GRADES_QUERY_SECTION)
  const s = qs.toString()
  return s ? `${ROUTES.GRADES}?${s}` : ROUTES.GRADES
}

export function gradesActasPath(params?: Record<string, string>): string {
  const qs = new URLSearchParams(params)
  qs.set(GRADES_QUERY_SECTION, GRADES_SECTION_ACTAS)
  return `${ROUTES.GRADES}?${qs.toString()}`
}

export function gradesCoursePath(courseId: number | string): string {
  return gradesCursadaPath({ curso: String(courseId) })
}

export function gradesActaCoursePath(courseId: number | string): string {
  return gradesActasPath({ curso: String(courseId) })
}

export function parentAttendancePath(studentId: number | string): string {
  return `${ROUTES.PARENT_ATTENDANCE}?alumno=${studentId}`
}

export function parentTutorPlanPath(studentId: number | string): string {
  return `${ROUTES.PARENT_TUTOR_PLAN}?alumno=${studentId}`
}

export function studyPlanCareerPath(careerId: number | string): string {
  return `${ROUTES.STUDY_PLAN_CAREER}/${careerId}`
}

export function actaBookDetailPath(
  bookId: number | string,
  institutionId?: number | null
): string {
  const base = `${ROUTES.ACTA_BOOK_DETAIL}/${bookId}`
  return institutionId != null ? `${base}?institutionId=${institutionId}` : base
}
